import {
  Button,
  Modal,
  Divider,
  Form,
  Input,
  message,
  Upload,
  Row,
  Col,
  Spin,
  Progress,
} from "antd";
import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import envConfig from "../config.json";
import {
  UploadOutlined,
  PlusOutlined,
  PlayCircleOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";

import "@google/model-viewer/dist/model-viewer";
import axios from "axios";
import "./ModelUpload.css";

const ModelUpload = (props) => {
  const { instance } = useMsal();
  const { fetchModels } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [title, setTitle] = useState("");
  const [tag, setTag] = useState("");
  const [icon, setIcon] = useState();
  const [asset, setAsset] = useState();
  const [showProgress, setShowProgress] = useState(false);
  const [previewImage, setPreviewImage] = useState();
  const [formKey, setFormKey] = useState(0);
  const [assetValidation, setAssetValidation] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [isUpload, setIsUpload] = useState(false);
  const [isSaving, setIsSaving] = useState(true);
  const [file, setFile] = useState();

  const msalToken = localStorage.getItem("msal.accesstoken");
  const config = {
    headers: {
      Authorization: `Bearer ${msalToken}`,
    },
    "Content-Type": "application/x-www-form-urlencoded",
  };
  /**
   * Function used to handle the icon stting
   * @param {*} e
   * @returns
   */
  const handleIcon = (e) => {
    const isJpgOrPng =
      e.file.type === "image/jpeg" || e.file.type === "image/png";
    const isLt2M = e.file.size / 1024 / 1024 < 10;
    if (!isJpgOrPng) {
      message.error({
        content: "You can only upload JPG/PNG file",
        className: 'custom-message-failure',
      });
      return;
    } else if (!isLt2M) {
      message.error({
        content: "Image must smaller than 10MB",
        className: 'custom-message-failure',
      });
      return;
    }
    const result = URL.createObjectURL(e.file);
    setPreviewImage(result);
    setIcon(e.file);
  };

  /**
   * Function to reset the fields
   */
  const resetFields = () => {
    setFormKey((formKey || 0) + 1);
    setTitle("");
    setTag("");
    setIcon();
    setAsset();
    setFile("");
    setPreviewImage(null);
  };
  /**
   * Function used to manage upload
   */
  const urlUpload = async (modelUrl, file) => {
    await readFileDataAsBuffer(file);
    await axios({
      method: "put",
      url: modelUrl, //API url
      data: file, // Buffer
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
  };
  /**
   * Function used to read the file as buffer
   */
  const readFileDataAsBuffer = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.onerror = (err) => {
        reject(err);
      };
      reader.readAsArrayBuffer(file);
    });
  };
  /**
   * Function to save model
   */
  const save3DCEModel = async () => {
    try {
      setShowProgress(true);
      setIsUpload(true);
      const token3DCE = localStorage.getItem("accesstokence");
      const thumbFields = {
        authToken: token3DCE,
        filename: icon?.name,
      };
      const thumbUpload = await axios.post(
        `${envConfig.aotmwapi}/api/3d-cms/continuumengine/asset`,
        thumbFields,
        config
      );
      await urlUpload(thumbUpload.data.url, icon);
      setUploadPercentage(50);
      const metaData = {
        assetType: "mesh",
        title: title,
        description: "",
        collections: "",
        tags: "",
        additionalMetadata: [],
        defaultMetadata: {    
          "Author": "AOT Author",
          "Copyright Notes": "AOT Copyright",
          "Owner": "AOT Owner",
          "Required Metadata": "AOT Required"
        },
        conversionDetails: {
          conversionFormats: ["glb"],
          addCollision: false,
          hasLod: false,
          levelOfDetails: [],
        },
        thumbnail: thumbUpload.data.key,
      };
      const assetFields = {
        authToken: token3DCE,
        filename: asset?.name,
        metadata: metaData,
      };
      const assetUpload = await axios.post(
        `${envConfig.aotmwapi}/api/3d-cms/continuumengine/asset`,
        assetFields,
        config
      );
      await urlUpload(assetUpload.data.url, asset);
      setUploadPercentage(100);
      setShowProgress(false);
      message.success({
        content: "Model uploaded successfully",
        className: 'custom-message-success',
      });
      resetFields();
      setIsModalVisible(false);
      setIsUpload(false);
      setUploadPercentage(0);
      fetchModels();
    } catch (error) {
      console.error("error in save3DCEModel");
      if (error.response.status === 401) {
        localStorage.removeItem("checkRole");
        const logoutRequest = {
          postLogoutRedirectUri: envConfig.redirectUri,
        };
        instance.logoutRedirect(logoutRequest);
      } else {
        message.error({
          content: "Model uploaded failed please try again",
          className: 'custom-message-failure',
        });
        setShowProgress(false);
        resetFields();
        setIsModalVisible(false);
        setIsUpload(false);
      }
    }
  };

  /**
   * Function used to set file props thumbnail
   */
  const filePropsThumbnail = {
    name: "files",
    multiple: false,
    onChange(info) {
      const { status } = info.file;
      if (status === "error") {
        message.error({
          content: `${info.file.name} file upload failed.`,
          className: 'custom-message-failure',
        });
      }
    },
    beforeUpload() {
      return false;
    },
  };
  /**
   * Function used to set modal visibility
   */
  const showModal = () => {
    setIsModalVisible(true);
  };
  /**
   * Function used to validate selected fields
   * @param {*} value
   * @returns
   */
  const validateSelectedFiles = (value) => {
    let ext = value.file.name.toLowerCase().split(".");
    ext = ext[ext.length - 1];
    if (ext === "gltf" || ext === "glb" || ext === "fbx" || ext === "obj") {
      setAssetValidation(false);
      setFile(URL.createObjectURL(value.file));
      setAsset(value.file);
    } else {
      setAssetValidation(true);
      message.error({
        content: "You can only upload GLTF/Glb/Fbx/Obj file",
        className: 'custom-message-failure',
      });
    }
  };
  /**
   * Fuction to handle cancel action
   */
  const handleCancel = () => {
    resetFields();
    setIsModalVisible(false);
  };
  /**
   * React hook to handle side effect
   */
  useEffect(() => {
    if (title && asset && icon && tag) {
      setIsSaving(false);
    } else {
      setIsSaving(true);
    }
  }, [title, asset, icon, tag]);

  return (
    <>
      <Button className="builderButton" onClick={showModal}>
        UPLOAD MODEL <UploadOutlined />
      </Button>
      <Modal
        title="UPLOAD MODEL"
        open={isModalVisible}
        onOk={save3DCEModel}
        onCancel={handleCancel}
        width={1000}
        bodyStyle={{ backgroundColor: "#262E40" }}
        footer={null}
        maskClosable={false}
        closable={!showProgress}
      >
        <Spin spinning={showProgress}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={12}>
              <div>
                <Form
                  name="model"
                  key={formKey}
                  layout="vertical"
                  initialValues={{
                    remember: true,
                  }}
                >
                  <Form.Item
                    label="Title"
                    name="title"
                    rules={[
                      {
                        required: true,
                        message: "Please enter title!",
                      },
                    ]}
                  >
                    <Input maxLength={50}
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      className="title"
                    />
                  </Form.Item>
                  <Form.Item
                    label="Tag"
                    name="tag"
                    value={tag}
                    onChange={(e) => setTag(e.target.value)}
                    rules={[
                      {
                        required: true,
                        message: "Please enter the tag!",
                      },
                    ]}
                  >
                    <Input maxLength={50} />
                  </Form.Item>
                  <Row gutter={16}>
                    <Col className="gutter-row" span={18}>
                      <Form.Item
                        name="asset"
                        label="3D File"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <Upload.Dragger
                          name="asset"
                          maxCount={1}
                          beforeUpload={() => false}
                          onChange={validateSelectedFiles}
                          onRemove={() => {
                            setFile(null);
                          }}
                        >
                          <p className="dropzone-icon">
                            <CloudUploadOutlined />
                          </p>
                          <p className="dropzone-text">
                            Drag and drop the asset or click to select files.
                            Please upload GLTF/Glb/Fbx/Obj file only
                          </p>
                        </Upload.Dragger>
                        {assetValidation ? (
                          <p className="error_color">
                            Please upload GLTF/Glb/Fbx/Obj file only
                          </p>
                        ) : null}
                      </Form.Item>
                    </Col>
                    <Col className="gutter-row" span={6}>
                      <Form.Item
                        label="Thumbnail"
                        name="Thumbnail"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                      >
                        <div className="clearfix">
                          {/* <Tooltip
                            title="Click to upload new thumbnail"
                            placement="bottomRight"
                          > */}
                          <Upload
                            {...filePropsThumbnail}
                            listType="picture-card"
                            showUploadList={false}
                            onChange={handleIcon}
                            onRemove={() => {
                              setPreviewImage(null);
                            }}
                          >
                            {previewImage ? (
                              <img
                                alt="preview"
                                className="imgWidth"
                                src={previewImage}
                              />
                            ) : (
                              <div>
                                <PlusOutlined />
                                <div className="ant-upload-text">
                                  Upload thumbnail
                                </div>
                              </div>
                            )}
                          </Upload>
                          {/* </Tooltip> */}
                          {/* <p id="thumbnail_error" style={{ color: "red" }}></p> */}
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                  {isUpload ? (
                    <Progress
                      strokeColor={{
                        "0%": "#108ee9",
                        "100%": "#87d068",
                      }}
                      percent={uploadPercentage}
                    />
                  ) : null}
                </Form>
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <div>
                <model-viewer
                  src={file}
                  shadow-intensity="1"
                  camera-controls
                  auto-rotate
                  ar
                  style={{
                    boxsizing: "border-box",
                    position: "absolute",
                    background: "#253546",
                    height: "-webkit-fill-available",
                    border: "1px solid #1D5F70",
                    width: "80%",
                  }}
                >
                  <div id="lazy-load-poster" slot="poster"></div>
                  <div id="button-load" slot="poster">
                    <PlayCircleOutlined /> Preview
                  </div>
                </model-viewer>
              </div>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={8}>
              <Button className="cancelButton" onClick={handleCancel}>
                Cancel{" "}
              </Button>
            </Col>
            <Col span={8} offset={8} className="divAlignRight">
              <Button
                style={{
                  backgroundColor: isSaving ? "#7a7a7a" : "#1d5f70",
                  color: isSaving ? "#999999" : "#01f1ff",
                  fontWeight: "700",
                  padding: "4px 64px",
                }}
                disabled={isSaving}
                onClick={() => save3DCEModel()}
              >
                UPLOAD MODEL
              </Button>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

export default ModelUpload;
